// extracted by mini-css-extract-plugin
export default {"Calendar":"HY7SS","Calendar--hasTime":"ajxp5","Calendar--withoutMonthsNavigation":"_4gMJv","Calendar--isMobile":"_1Ucx9","skeleton-progress":"XSsTX"};